import React, { useEffect } from "react";
import { Route, useLocation, useNavigate } from "react-router-dom";
import { Wrapper } from "../Components/Utils/roles";

import ShippingMain from "../Views/Web/Shipping/MainShipping";
import AgentsMain from "../Views/Web/Shipping/Agents/AgentsMain";
import { ShipmentTrackingMain, ShipmentTrackingIndex, CreateShipmentTracking, EditShipmentTracking, ViewShipmentTracking } from "../Views/Web/Shipping/ShipmentTracking";

import AgentIndex from "../Views/Web/Shipping/Agents";
import CreateAgents from "../Views/Web/Shipping/Agents/CreateAgents";
import EditAgents from "../Views/Web/Shipping/Agents/EditAgents";
import ViewAgents from "../Views/Web/Shipping/Agents/ViewAgents";

import ShippingComparisonMain from "../Views/Web/Shipping/ShippingComparison/ShippingComparisonMain";
import ShippingComparisonIndex from "../Views/Web/Shipping/ShippingComparison/index";
import CreateShippingComparison from "../Views/Web/Shipping/ShippingComparison/CreateShippingComparison";
import EditShippingComparison from "../Views/Web/Shipping/ShippingComparison/EditShippingComparison";
import ViewShippingComparison from "../Views/Web/Shipping/ShippingComparison/ViewShippingComparison";
import AgentPriceListing from "../Views/Web/Shipping/ShippingComparison/AgentPriceListing";

function ShippingRoutes() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (
            location.pathname === "/shipping" ||
            location.pathname === "/shipping/") {
            navigate("/page-not-found")
        }
    }, [location])
    return (
        <Route path="shipping" element={<ShippingMain />}>
            <Route path="agents" element={<AgentsMain />}>
                <Route index element={<Wrapper permissionKey={"agents_view"} Component={AgentIndex} />} />
                <Route path="create" element={<Wrapper permissionKey={"agents_create"} Component={CreateAgents} />} />
                <Route path="edit/:agentsEditId" element={<Wrapper permissionKey={"agents_edit"} Component={EditAgents} />} />
                <Route path="view/:agentsViewId" element={<Wrapper permissionKey={"agents_view"} Component={ViewAgents} />} />
            </Route>
            <Route path="shipment-tracking" element={<ShipmentTrackingMain />}>
                <Route index element={<Wrapper permissionKey={"shipment_tracking_view"} Component={ShipmentTrackingIndex} />} />
                <Route path="create" element={<Wrapper permissionKey={"shipment_tracking_create"} Component={CreateShipmentTracking} />} />
                <Route path="edit/:shipmentTrackingEditId" element={<Wrapper permissionKey={"shipment_tracking_edit"} Component={EditShipmentTracking} />} />
                <Route path="view/:shipmentTrackingViewId" element={<Wrapper permissionKey={"shipment_tracking_view"} Component={ViewShipmentTracking} />} />
            </Route>
            <Route path="shipping-comparison" element={<ShippingComparisonMain />}>
                <Route index element={<Wrapper permissionKey={"shipping_comparison_view"} Component={ShippingComparisonIndex} />} />
                <Route path="create" element={<Wrapper permissionKey={"shipping_comparison_create"} Component={CreateShippingComparison} />} />
                <Route path="edit/:comparisonId" element={<Wrapper permissionKey={"shipping_comparison_edit"} Component={EditShippingComparison} />} />
                <Route path="view/:comparisonId" element={<Wrapper permissionKey={"shipping_comparison_view"} Component={ViewShippingComparison} />} />
                <Route path="priceView/:comparisonId/:agentId" element={<Wrapper permissionKey={"shipping_comparison_view"} Component={AgentPriceListing} />} />
            </Route>
        </Route>
    )
}

export default ShippingRoutes;